export interface ClientLogo {
  name: string
  logo: string
  bgClass: string
}

export const clientLogos: ClientLogo[] = [
  {
    name: 'Zepter',
    logo: 'https://cdn.magicpatterns.com/uploads/oimH959y7MFm95LWY6Mf4J/zepterlogo.png.webp',
    bgClass: 'bg-navy-900',
  },
  {
    name: 'Payler',
    logo: 'https://cdn.magicpatterns.com/uploads/2Tf5zq3Rg6ViugFDm1umxq/Payler_LOGO.svg',
    bgClass: 'bg-white',
  },
  {
    name: 'SBSB',
    logo: 'https://cdn.magicpatterns.com/uploads/3r829MxxY4Zb8rmDEqw7ya/logo_white.svg',
    bgClass: 'bg-navy-900',
  },
  {
    name: 'PPL Digital Solutions',
    logo: 'https://cdn.magicpatterns.com/uploads/eG8FkXSDcMzJC2cLkUkPoe/ppl-09.png.webp',
    bgClass: 'bg-white',
  },
  {
    name: 'RocketFirm',
    logo: 'https://cdn.magicpatterns.com/uploads/5w3zS993Pxoqj95Hy2vzMQ/logo_(2).svg',
    bgClass: 'bg-navy-900',
  },
  {
    name: 'DoktorPro',
    logo: 'https://cdn.magicpatterns.com/uploads/5nwZaaK5RLvjRA1VYMUZ1N/photo.png.webp',
    bgClass: 'bg-white',
  },
  {
    name: 'IT4Medicine',
    logo: 'https://cdn.magicpatterns.com/uploads/73hYRhWL7ZkuTp9xsY1g77/tild3035-3836-4732-b.png.webp',
    bgClass: 'bg-white',
  },
  {
    name: 'DevPower',
    logo: 'https://cdn.magicpatterns.com/uploads/gRKRFNNBxY2ak5judA1bpM/logo.png.webp',
    bgClass: 'bg-white',
  },
  {
    name: 'Finbert',
    logo: 'https://cdn.magicpatterns.com/uploads/iegHNv4UYoz22TzxaDmyEu/logo_1.svg',
    bgClass: 'bg-white',
  },
  {
    name: 'SYNLAB',
    logo: 'https://cdn.magicpatterns.com/uploads/uW6JAwYH6bGamxicED36F3/photo.png_(3).webp',
    bgClass: 'bg-white',
  },
  {
    name: 'Vortex Plus',
    logo: 'https://cdn.magicpatterns.com/uploads/aWKfYkcsM7UGZfbvHM1eVs/__3.jpeg.webp',
    bgClass: 'bg-white',
  },
  {
    name: 'Sherpa',
    logo: 'https://cdn.magicpatterns.com/uploads/jrAWS1PJLLj4yAAbfysZg3/photo.png_(1).webp',
    bgClass: 'bg-white',
  },
  {
    name: 'Diamond Pharm',
    logo: 'https://cdn.magicpatterns.com/uploads/bATtCF4q8ST2tFfDTHwCv9/photo.png_(2).webp',
    bgClass: 'bg-white',
  },
  {
    name: 'British International School',
    logo: 'https://cdn.magicpatterns.com/uploads/dHFgbKCnhkZwU17PwUzhyY/photo.jpeg.webp',
    bgClass: 'bg-navy-900',
  },
  {
    name: 'Chipita',
    logo: 'https://cdn.magicpatterns.com/uploads/jVweTN6kAzoD2yBbjKELXV/__1.jpeg.webp',
    bgClass: 'bg-white',
  },
]
